import React from 'react'
import styled from 'styled-components'
import { media } from 'src/styles/styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'

const StyledContainer = styled(ArBaseContainer)`
  align-items:center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${ ({ mobileContainerStyles }) => mobileContainerStyles }
  ${ media.tablet`${ ({ tabletContainerStyles }) => tabletContainerStyles }` }
  ${ media.desktop`${ ({ desktopContainerStyles }) => desktopContainerStyles }` }
`

function ArHeroContainer ({ children, ...rest }) {
  return (
    <StyledContainer {...rest}>
      {children}
    </StyledContainer>
  )
}

export default ArHeroContainer
